import { API_URL } from 'src/config'
import { IntervenerDireccion } from 'src/interfaces/EscritosLegales'
import http from 'src/utils/Http'

export function getIntervenerAddressData(
  pais: string,
  tipoVia: string,
  municipio: string,
  provincia: string
): Promise<IntervenerDireccion> {
  return http.post({
    url: `${API_URL}/lexon/intervenerAddressData`,
    token: true,
    params: {
      pais,
      tipoVia,
      municipio,
      provincia
    }
  })
}
